export default __webpack_public_path__ + "static/media/arrow-up.cffc18f3.svg";